type CallerPatientInfo = {
    callerFirstName?: string;
    callerLastName?: string;
};

export const getUserName = ({callerFirstName = '', callerLastName = ''}: CallerPatientInfo): string => {
    if (callerLastName && callerFirstName) {
        return `${callerLastName}, ${callerFirstName}`;
    }

    if (callerLastName) return callerLastName;
    if (callerFirstName) return callerFirstName;

    return 'Unknown';
};
